import { useState, useEffect } from "react";

const TRANSLATIONS = {
  en: {
    // Survey
    survey_title: "Satisfaction Survey",
    survey_subtitle: "Your opinion matters",
    survey_enter_code: "Enter your client code to begin",
    survey_code_label: "Client Code",
    survey_code_placeholder: "E.g.: AB3K9F",
    survey_code_help: "6-character code provided by Sally Better",
    survey_verify: "Verify Code",
    survey_no_code: "Don't have a code? Contact Sally Better to get one.",
    survey_hello: "Hello",
    survey_tell_experience: "tell us about your experience.",
    survey_q1: "1. How satisfied are you with the product received?",
    survey_very_unsatisfied: "Very unsatisfied",
    survey_very_satisfied: "Very satisfied",
    survey_of: "of",
    survey_q2: "2. How do you rate the print quality?",
    survey_q3: "3. Did the delivery time meet your expectations?",
    survey_q4: "4. Would you buy from us again?",
    survey_yes: "Yes",
    survey_no: "No",
    survey_q5: "5. What could we improve?",
    survey_q5_sub: "Optional - Your suggestions help us improve",
    survey_suggestions_placeholder: "Write your suggestions here...",
    survey_submit: "Submit Survey",
    survey_submitting: "Submitting...",
    survey_consent: "By submitting this survey, you agree that we may use your feedback anonymously.",
    survey_thanks_title: "Thank you for your feedback!",
    survey_thanks_sub: "Your opinion helps us keep improving our products and services.",
    survey_coupon_title: "You have a discount coupon!",
    survey_coupon_present: "Present this code on your next purchase.",
    survey_discount: "discount",
    survey_back_home: "Back to home",
    quality_excellent: "Excellent",
    quality_good: "Good",
    quality_fair: "Fair",
    quality_poor: "Poor",
    // Tracking
    tracking_title: "Order Tracking",
    tracking_subtitle: "Check the status of your order",
    tracking_search_placeholder: "Tracking number (e.g.: SB-2026-123456)",
    tracking_not_found: "Order not found. Please verify the tracking number.",
    tracking_number: "Tracking Number",
    tracking_current: "Current",
    tracking_pending: "Pending",
    tracking_order_details: "Order Details",
    tracking_created: "Created",
    tracking_carrier: "Shipping Tracking",
    tracking_track: "Track shipment",
    tracking_received: "Received",
    tracking_in_progress: "In Progress",
    tracking_shipped: "Shipped",
    tracking_delivered: "Delivered",
    // Register
    register_title: "Client Registration",
    register_subtitle: "Fill in your details to register as a Sally Better client",
    register_name: "Name *",
    register_email: "Email *",
    register_phone: "Phone",
    register_street: "Street Address",
    register_unit: "Unit, Apt or Suite",
    register_city: "City",
    register_state: "State",
    register_zip: "Zip Code",
    register_services: "Services of Interest",
    register_submit: "Register",
    register_consent: "Upon registration, you will receive a client code by email once approved.",
    register_success_title: "Registration Successful!",
    register_success_sub: "Your request has been sent.",
    register_success_info: "You will receive an email with your client code once your account is approved.",
    register_back: "Back to home",
  },
  es: {
    survey_title: "Encuesta de Satisfacción",
    survey_subtitle: "Tu opinión importa",
    survey_enter_code: "Ingresa tu código de cliente para comenzar",
    survey_code_label: "Código de Cliente",
    survey_code_placeholder: "Ej: AB3K9F",
    survey_code_help: "Código de 6 caracteres proporcionado por Sally Better",
    survey_verify: "Verificar Código",
    survey_no_code: "¿No tienes un código? Contacta a Sally Better para obtener uno.",
    survey_hello: "Hola",
    survey_tell_experience: "cuéntanos tu experiencia.",
    survey_q1: "1. ¿Qué tan satisfecho estás con el producto recibido?",
    survey_very_unsatisfied: "Muy insatisfecho",
    survey_very_satisfied: "Muy satisfecho",
    survey_of: "de",
    survey_q2: "2. ¿Cómo calificas la calidad de impresión?",
    survey_q3: "3. ¿El tiempo de entrega cumplió tus expectativas?",
    survey_q4: "4. ¿Volverías a comprar con nosotros?",
    survey_yes: "Sí",
    survey_no: "No",
    survey_q5: "5. ¿Qué podríamos mejorar?",
    survey_q5_sub: "Opcional - Tus sugerencias nos ayudan a mejorar",
    survey_suggestions_placeholder: "Escribe aquí tus sugerencias...",
    survey_submit: "Enviar Encuesta",
    survey_submitting: "Enviando...",
    survey_consent: "Al enviar esta encuesta, aceptas que podamos usar tu opinión de forma anónima.",
    survey_thanks_title: "¡Gracias por tu opinión!",
    survey_thanks_sub: "Tu opinión nos ayuda a seguir mejorando nuestros productos y servicios.",
    survey_coupon_title: "¡Tienes un cupón de descuento!",
    survey_coupon_present: "Presenta este código en tu próxima compra.",
    survey_discount: "de descuento",
    survey_back_home: "Volver al inicio",
    quality_excellent: "Excelente",
    quality_good: "Buena",
    quality_fair: "Regular",
    quality_poor: "Mala",
    tracking_title: "Seguimiento de Pedido",
    tracking_subtitle: "Consulta el estado de tu pedido",
    tracking_search_placeholder: "Número de seguimiento (ej: SB-2026-123456)",
    tracking_not_found: "Pedido no encontrado. Verifica el número de seguimiento.",
    tracking_number: "Número de Seguimiento",
    tracking_current: "Actual",
    tracking_pending: "Pendiente",
    tracking_order_details: "Detalle del Pedido",
    tracking_created: "Creado",
    tracking_carrier: "Rastreo del Envío",
    tracking_track: "Rastrear envío",
    tracking_received: "Recibido",
    tracking_in_progress: "En Proceso",
    tracking_shipped: "Enviado",
    tracking_delivered: "Entregado",
    register_title: "Registro de Cliente",
    register_subtitle: "Completa tus datos para registrarte como cliente de Sally Better",
    register_name: "Nombre *",
    register_email: "Correo Electrónico *",
    register_phone: "Teléfono",
    register_street: "Dirección de la Calle",
    register_unit: "Número de Unidad, Apto o Suite",
    register_city: "Ciudad",
    register_state: "Estado",
    register_zip: "Código Postal",
    register_services: "Servicios de Interés",
    register_submit: "Registrarme",
    register_consent: "Al registrarte, recibirás un código de cliente por correo una vez aprobado.",
    register_success_title: "¡Registro Exitoso!",
    register_success_sub: "Tu solicitud ha sido enviada.",
    register_success_info: "Recibirás un correo electrónico con tu código de cliente una vez que tu cuenta sea aprobada.",
    register_back: "Volver al inicio",
  }
};

function detectBrowserLang() {
  const nav = navigator.language || navigator.userLanguage || "en";
  return nav.startsWith("es") ? "es" : "en";
}

export function usePublicLang() {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("publicLang");
    return saved || detectBrowserLang();
  });

  useEffect(() => {
    localStorage.setItem("publicLang", lang);
  }, [lang]);

  const t = (key) => TRANSLATIONS[lang]?.[key] || TRANSLATIONS.en[key] || key;

  return { lang, setLang, t };
}

export function LangToggle({ lang, setLang }) {
  return (
    <div className="flex items-center gap-1 bg-white/10 rounded-full p-1" data-testid="lang-toggle">
      <button
        onClick={() => setLang("en")}
        className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${lang === "en" ? "bg-white text-stone-900" : "text-white/60 hover:text-white"}`}
        data-testid="lang-en"
      >
        EN
      </button>
      <button
        onClick={() => setLang("es")}
        className={`px-3 py-1 rounded-full text-sm font-medium transition-all ${lang === "es" ? "bg-white text-stone-900" : "text-white/60 hover:text-white"}`}
        data-testid="lang-es"
      >
        ES
      </button>
    </div>
  );
}
